import "./index.css";
import reportWebVitals from "./reportWebVitals";

import "./i18n";

import smoothscroll from "smoothscroll-polyfill";

import { Provider } from "react-redux";

import { store } from "store/store";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";
import App from "App";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

const gtmParams = { id: "GTM-TDQ4FDX" };
smoothscroll.polyfill();

const root = createRoot(document.getElementById("root"));
root.render(
    <StrictMode>
        <GTMProvider {...gtmParams}>
            <Provider store={store}>
                <App />
            </Provider>
        </GTMProvider>
    </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
